import { render, staticRenderFns } from "./VInputCode.vue?vue&type=template&id=5b406b24&scoped=true&"
import script from "./VInputCode.vue?vue&type=script&lang=js&"
export * from "./VInputCode.vue?vue&type=script&lang=js&"
import style0 from "./VInputCode.vue?vue&type=style&index=0&id=5b406b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b406b24",
  null
  
)

export default component.exports